import './slopesOverview.scss';

import { FormattedMessage } from 'react-intl';

import { SlopeBadge, StatItem } from '~atoms';
import { Maybe } from '~types/appsync.types';

interface SlopesOverviewProps {
  tagline?: Maybe<string>;
  numTotalSlopes?: Maybe<number>;
  numSkiLift?: Maybe<number>;
  numKmSlope?: Maybe<number>;
  numGreenSlopes?: Maybe<number>;
  numBlueSlopes?: Maybe<number>;
  numRedSlopes?: Maybe<number>;
  numBlackSlopes?: Maybe<number>;
}

const SlopesOverview = ({
  tagline,
  numTotalSlopes,
  numSkiLift,
  numKmSlope,
  numGreenSlopes,
  numBlueSlopes,
  numRedSlopes,
  numBlackSlopes,
}: SlopesOverviewProps) => {
  const totalSlopes = numTotalSlopes ?? 0;
  const skiLifts = numSkiLift ?? 0;
  const kmSlope = numKmSlope ?? 0;
  const greenSlopes = numGreenSlopes ?? 0;
  const blueSlopes = numBlueSlopes ?? 0;
  const redSlopes = numRedSlopes ?? 0;
  const blackSlopes = numBlackSlopes ?? 0;

  return (
    <section className='SlopesOverview'>
      {tagline && <div className='SlopesOverview_tagline'>{tagline}</div>}

      <div className='SlopesOverview_summary'>
        {totalSlopes > 0 && (
          <StatItem
            icon='mountain-mountain'
            count={totalSlopes}
            labelId='slopes'
            defaultMessage='slopes'
          />
        )}

        {skiLifts > 0 && (
          <StatItem
            icon='mountain-lift'
            count={skiLifts}
            labelId='skiLifts'
            defaultMessage='ski lifts'
          />
        )}
        {kmSlope > 0 && (
          <StatItem
            icon='mountain-slope'
            count={kmSlope}
            labelId='kmOfSlopes'
            defaultMessage='km of slopes'
          />
        )}
      </div>

      {(greenSlopes || blueSlopes || redSlopes || blackSlopes) > 0 && (
        <div className='SlopesOverview_breakdown' aria-labelledby='SlopesOverview_breakdownTitle'>
          <div id='SlopesOverview_breakdownTitle'>
            <FormattedMessage id='slopesBreakdown' defaultMessage='Slopes breakdown' />
          </div>
          <div className='SlopesOverview_breakdownDetails'>
            {greenSlopes > 0 && <SlopeBadge color='green' count={greenSlopes} />}
            {blueSlopes > 0 && <SlopeBadge color='blue' count={blueSlopes} />}
            {redSlopes > 0 && <SlopeBadge color='red' count={redSlopes} />}
            {blackSlopes > 0 && <SlopeBadge color='black' count={blackSlopes} />}
          </div>
        </div>
      )}
    </section>
  );
};

export default SlopesOverview;
